// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__eBua3","clickable":"styles_clickable__dN6kV","disabled":"styles_disabled__t-A9e"};